module.exports = __webpack_public_path__ + "assets/images/128045cadd0bdbafa45a847eb33fc89b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icons/goodreads.svg
// module id = 727
// module chunks = 0